import React from "react";
import { Handle } from "reactflow";
import "./FillReportNode.scss";
import { Summarize } from "@mui/icons-material";
import useVerifyConnection from "../../../../../hooks/useVerifyConnection";

function FillReportNode({ selected }) {
    const verifyConnection = useVerifyConnection();

    return (
        <>
            <Handle
                type="source"
                position="right"
                isValidConnection={verifyConnection}
            />
            <div
                className={`fill-report-node-container${
                    selected ? " selected" : ""
                }`}
            >
                <div className="fill-report-content">
                    <Summarize fontSize="large" />
                </div>
            </div>
            <Handle
                type="target"
                position="left"
                isValidConnection={verifyConnection}
            />
        </>
    );
}

export default FillReportNode;
